import { option_privacy_searchHistory } from './PrivacyOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';

var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let PrivacyOption: LazyOption = createLazyOption(
    {
        key: 'search',
        titleStringKey: option_privacy_searchHistory,
        searchTermsStringKey: option_privacy_searchHistory,
    },
    lazyFullModule,
    m => m.default
);
export default PrivacyOption;
